AddPageSwapTrigger(function() {

    $('.viewmore_container .bekijkmeer').unbind('click');
    $('.viewmore_container .bekijkmeer').click(function (e) {
        e.preventDefault();
        $(this).hide();
        $(this).parent().find('.bekijkminder').show();
        $(this).parent().find('.viewmore_short').hide();
        $(this).parent().find('.viewmore_full').show();
    });
    $('.viewmore_container .bekijkminder').unbind('click');
    $('.viewmore_container .bekijkminder').click(function (e) {
        e.preventDefault();
        $(this).hide();
        $(this).parent().find('.bekijkmeer').show();
        $(this).parent().find('.viewmore_short').show();
        $(this).parent().find('.viewmore_full').hide();
    });
})